export const SET_EMPTY_INFO = "SET_EMPTY_INFO";

export function actionSetEmptyInfoMessage(data) {
    return { type: SET_EMPTY_INFO, data };
}